import {CanDeactivateFn} from '@angular/router';
import {inject} from '@angular/core';
import {NzModalService} from 'ng-zorro-antd/modal';
import {TranslateService} from '@ngx-translate/core';

export interface CanComponentDeactivate {
  canDeactivate: () => boolean;
}

export const unsavedChangesGuard: CanDeactivateFn<CanComponentDeactivate> = (
  component: CanComponentDeactivate,
) => {
  const canDeactivate = component.canDeactivate ? component.canDeactivate() : true;

  if (canDeactivate) {
    return true;
  }

  const modalService = inject(NzModalService);
  const translateService = inject(TranslateService);

  return new Promise<boolean>(resolve => {
    modalService.confirm({
      nzTitle: translateService.instant('labels.unsavedChanges'),
      nzContent: '<b>' + translateService.instant('labels.unsavedChangesWarning') + '</b>',
      nzOkText: translateService.instant('buttons.no'),
      nzOkType: 'primary',
      nzOkDanger: true,
      nzOnOk: () => resolve(false),
      nzCancelText: translateService.instant('buttons.yes'),
      nzOnCancel: () => resolve(true),
    });
  });
};
